import {Tag} from "../types";
import React from "react";
import {getProgressStage, getProgressStepId, parseProgressContent} from "./utils";
import {HiOutlineCog} from "react-icons/hi";

interface ProgressSectionProps {
  stableKey: string;
  tags: Tag[];
  progressEndState: any;
  hideHeader?: boolean;
}

const ProgressSection: React.FC<ProgressSectionProps> = ({ stableKey, tags, progressEndState, hideHeader = false })=> {
  const renderedStepIds = new Set();

  const progressSteps = tags.filter((tag) => {
    const stepId = getProgressStepId(tag.content);

    if (renderedStepIds.has(stepId)) return false;

    renderedStepIds.add(stepId);
    return true;
  });

  return (
    <div key={stableKey} className="progress-section timeline-node">
      {!hideHeader && (
        <div className="progress-header">
          <div className="progress-title">
            <HiOutlineCog className="w-3 h-3" />
            <span>Processing</span>
          </div>
        </div>
      )}
      <div className="progress-content">
        {progressSteps.map((tag) => {
          const stepId = getProgressStepId(tag.content);
          const stepTags = tags.filter(t => getProgressStepId(t.content) === stepId);

          const startTag = stepTags.find(t => getProgressStage(t.content) === "start");
          const endTag = stepTags.find(t => getProgressStage(t.content) === "end");

          let messageToShow = null;
          if (startTag && endTag) {
            messageToShow = !progressEndState[stepId]
              ? parseProgressContent(startTag.content)
              : parseProgressContent(endTag.content);
          } else if (endTag) {
            messageToShow = parseProgressContent(endTag.content);
          } else if (startTag) {
            messageToShow = parseProgressContent(startTag.content);
          }

          return (
            <div key={`progress-msg-${stepId}`} className="markdown-content mb-2">
              <p>{messageToShow}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ProgressSection;